import { render, staticRenderFns } from "./2Columns.vue?vue&type=template&id=90ca5b50"
import script from "./2Columns.vue?vue&type=script&lang=js"
export * from "./2Columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports